/**
 * Owns add-to-cart interactions inside the custom homepage course carousel.
 */
(() => {
  const FORM_SELECTOR = '#ym-ps .yp-ajax-form';

  const animateToCart = (button, form) => {
    if (!customElements.get('fly-to-cart')) return;

    const destination = document.querySelector('.header-actions__cart-icon');
    if (!destination) return;

    const courseImage = form.closest('.yp-card')?.querySelector('.yp-img-wrap img');
    const flight = document.createElement('fly-to-cart');

    if (courseImage?.currentSrc) flight.style.backgroundImage = `url("${courseImage.currentSrc}")`;
    flight.source = button;
    flight.destination = destination;
    document.body.appendChild(flight);
  };

  document.addEventListener(
    'submit',
    async (event) => {
      if (!(event.target instanceof Element)) return;
      const form = event.target.closest(FORM_SELECTOR);
      if (!form) return;

      // Override the legacy inline listener before it can send a duplicate request.
      event.preventDefault();
      event.stopImmediatePropagation();

      const button = form.querySelector('.yp-btn-cart');
      if (!button || button.disabled) return;

      const originalText = button.textContent;
      const formData = new FormData(form);

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Ekleniyor…';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
        });

        if (!response.ok) throw new Error('Cart add request failed');

        const cartResponse = await fetch(`/cart.js?ym_cart_check=${Date.now()}`, {
          headers: { Accept: 'application/json' },
          cache: 'no-store',
        });
        if (!cartResponse.ok) throw new Error('Cart verification request failed');
        const cart = await cartResponse.json();

        button.textContent = 'Sepete eklendi ✓';
        button.classList.add('is-added');
        animateToCart(button, form);

        // Send the verified total rather than incrementing a potentially stale UI count.
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            detail: { resource: cart, data: { itemCount: cart.item_count, source: 'verified-cart' } },
          })
        );
      } catch (error) {
        console.error('Sepete eklenemedi:', error);
        button.textContent = 'Tekrar dene';
      } finally {
        window.setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.classList.remove('is-added');
        }, 1800);
      }
    },
    true
  );
})();